import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const rootElement = document.getElementById('root')
    if (rootElement) {
      rootElement.scrollTo(0, 0)
    }
  }, [pathname])

  return null
}

export default ScrollToTop
